<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Input RO</div>
		</div>
		<div class="mt-5">
			<div v-if="!suksesRO">
				<div v-if="!loading">
					<div class="text-right">
						<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showInputRO">Input RO Manual</v-btn>
					</div>
					<div class="pb-3 font-size-11 grey--text text--darken-1 font-weight-bold">List Serial</div>
					<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
						<div v-if="serialROAvaList.length > 0">
							<v-row class="ml-0">
								<v-col cols="12" sm="6" md="3" xl="3" class="pl-0 pb-0" v-for="(serial, i) in serialROAvaList" :key="i">
									<v-card class="pa-3 elevation-0 rounded-xl hover-shadow" @click="checkSerial(serial, serial.serial_member_serial_id)">
										<v-row>
											<v-col cols="2" sm="2" md="2" class="my-auto">
												<v-checkbox hide-details class="mt-0 pt-0 mr-0" on-icon="mdi-check-circle" off-icon="mdi-checkbox-blank-circle-outline" v-model="serial.checked" @click="checkSerial(serial, serial.serial_member_serial_id)"></v-checkbox>
											</v-col>
											<v-col cols="10" sm="10" md="10" class="my-auto">
												<div class="d-flex flex-wrap">
													<v-col cols="12" md="12" class="pa-0 d-flex flex-row align-center justify-space-between">
														<div class="font-size-10 cl-grey">Serial</div>
														<div class="font-size-10 font-size-xs-11 primary--text font-weight-600">{{ serial.serial_member_serial_id }}</div>
													</v-col>
													<v-col cols="12" md="12" class="px-0 pt-1 pb-0 d-flex flex-row align-center justify-space-between">
														<div class="font-size-10 cl-grey">Pembelian</div>
														<div class="font-size-10 font-size-xs-11 cl-grey font-weight-600">{{ serial.serial_member_serial_buy_datetime | toDate }}</div>
													</v-col>
												</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-row>
							<div class="my-3">
								<v-row justify="center">
									<template>
										<v-col cols="9" sm="4" md="3" xl="2" v-if="serialROAvaPagination.total_page > 1 && serialROAvaPagination.next > 0">
											<v-btn block large outlined class="bg-white text-capitalize rounded-xl" color="primary" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="loadMore">
												<v-icon>mdi-sync-circle</v-icon>
												<span class="pl-2">Muat Lebih Banyak</span>
											</v-btn>
										</v-col>
									</template>
									<v-col cols="9" sm="3" md="2" xl="1" class="pt-0 pt-sm-3 pl-sm-0">
										<v-btn block large depressed class="bg-primary white--text text-capitalize rounded-xl" :loading="btnLoadingProses" :disabled="serialData.length <= 0" @click="showConfirm">
											<v-icon>mdi-arrow-right-bold-circle</v-icon>
											<span class="pl-2">Proses</span>
										</v-btn>
									</v-col>
								</v-row>
							</div>
						</div>
					</v-scroll-x-reverse-transition>
					<div v-if="serialROAvaList.length == 0">
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
									<NoData></NoData>
									<div class="pt-3 font-size-11 text-center cl-secondary">Tidak ada data serial yang dapat ditampilkan</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
				</div>
				<div class="mt-3" v-if="loading">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<LoadData :loading="loading"></LoadData>
						</v-col>
					</v-row>
				</div>
			</div>
			<div v-if="suksesRO">
				<v-row>
					<v-col cols="12">
						<v-card class="pa-3 elevation-0 rounded-xl">
							<div class="d-flex flex-wrap justify-center">
								<v-col cols="3">
									<v-img src="/assets/ilustration/confirm-vo.svg"></v-img>
								</v-col>
								<v-col cols="12" class="text-center">
									<div class="font-size-11 grey--text text--darken-3">Anda Berhasil Melakukan Repeat Order Dengan Serial</div>
									<div class="grey--text text--darken-1 font-weight-bold">
										<span v-for="(serial, i) in successResponse" :key="i">{{ serial.serial_id + (i != successResponse.length - 1 ? ',' : '') }}</span>
									</div>
								</v-col>
								<v-col cols="12">
									<div class="text-center">
										<v-btn large depressed class="bg-primary white--text rounded-xl" :loading="btnLoadingBack" :disabled="btnLoadingBack" @click="backInput">
											<v-icon>mdi-credit-card-sync-outline</v-icon>
											<span class="pl-2 text-capitalize">Input RO Lagi</span>
										</v-btn>
									</div>
								</v-col>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
		</div>
		<ModalInputRO ref="modalInputRO" @action="handleInputROManual"></ModalInputRO>
		<ModalKonfirmasi ref="modalKonfirmasi" :msg="msgConfirm" @action="processRO"></ModalKonfirmasi>
		<ModalKonfirmasiManual ref="modalKonfirmasiManual" :msg="msgConfirm" @action="processROManual"></ModalKonfirmasiManual>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalInputRO from './components/ModalInputRO'
import ModalKonfirmasi from '@/components/modals/vo-general/ModalKonfirmasi'
import ModalKonfirmasiManual from '@/components/modals/vo-general/ModalKonfirmasi'

export default {
	components: {
		ModalInputRO, ModalKonfirmasi, ModalKonfirmasiManual
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '12',
			btnLoadingProses: false,
			btnProses: true,
			btnLoadingBack: false,
			suksesRO: false,
			serialData: [],
			serialParams: {
				serial: [],
			},
			msgConfirm: 'Yakin ingin melakukan Repeat Order?',
		}
	},
	computed: {
		...mapState('serial', ['serialROAvaList', 'serialROAvaPagination']),
		...mapState(['successResponse']),
	},
	methods: {
		...mapActions('serial', ['getSerialROAvaList', 'getLoadSerialROAvaList']),
		...mapActions('repeatOrder', ['addRO']),

		getData() {
			this.loading = true
			this.getSerialROAvaList({ limit:this.limit, page: this.page, sort: 'serial_member_serial_buy_datetime', dir: 'asc' }).then(() => {
				this.loading = false
			})
		},
		checkSerial(serial, id) {
			if (serial.checked) {
				serial.checked = false
			} else {
				serial.checked = true
			}

			if (serial.checked == true) {
				this.serialData.push(serial)
			} else {
				this.serialData = this.serialData.filter(function(item) {
					return item.serial_member_serial_id !== id
				})
			}
		},
		loadMore() {
			this.btnLoadingProses = true
			this.page += 1
			this.getLoadSerialROAvaList({ limit:this.limit, page: this.page, sort: 'serial_member_serial_buy_datetime', dir: 'asc' }).then(() => {
				this.btnLoadingProses = false
			})
		},
		showConfirm() {
			this.$refs.modalKonfirmasi.modalShow()
		},
		processRO() {
			this.serialData.forEach((el) => {
				let data = {
					serial_id: '',
					serial_pin: '',
				}
				data.serial_id = el.serial_member_serial_id
				data.serial_pin = el.serial_member_serial_pin
				this.serialParams.serial.push(data)
			})
			this.$refs.modalKonfirmasi.loadingButton()
			this.addRO(this.serialParams).then(() => {
				this.serialData = []
				this.serialParams.serial = []
				this.$refs.modalKonfirmasi.normalButton()
				this.$refs.modalKonfirmasi.modalHide()
				this.suksesRO = true
			}).catch(() => {
				this.serialParams.serial = []
				this.$refs.modalKonfirmasi.normalButton()
				this.$refs.modalKonfirmasi.modalHide()
			})
		},
		showInputRO() {
			this.$refs.modalInputRO.modalShow()
		},
		processROManual() {
			this.$refs.modalKonfirmasiManual.loadingButton()
			this.$refs.modalInputRO.processRO()
		},
		handleInputROManual(val) {
			if (val == 'show') {
				this.$refs.modalKonfirmasiManual.modalShow()
			} else if (val == 'error') {
				this.$refs.modalKonfirmasiManual.normalButton()
				this.$refs.modalKonfirmasiManual.modalHide()
			} else {
				this.$refs.modalKonfirmasiManual.normalButton()
				this.$refs.modalKonfirmasiManual.modalHide()
				this.suksesRO = true
			}
		},
		backInput() {
			this.page = 1
			this.btnLoadingBack = true
			this.btnProses = true
			this.getSerialROAvaList({ limit:this.limit, page: this.page, sort: 'serial_member_serial_buy_datetime', dir: 'asc' }).then(() => {
				this.btnLoadingBack = false
				this.suksesRO = false
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Input RO`)
		this.getData()
	}
};
</script>